(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .controller('RecomUpdateStatusAssessActionPlansListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'notificationService', 'bUnit', 'govProcess', 'actionPlansByAssessor'];

    function Controller($scope, $state, topBarService, notificationService, bUnit, govProcess, actionPlansByAssessor) {

        if ($state.is('recomActionPlanUpdateStatusAssess.actionPlans')) {
            var areAllActionPlansNotAssessed = _.every(actionPlansByAssessor, { ActionPlanAssessment: { IsLocked: false } });
            var actionPlanToAssess = _.find(actionPlansByAssessor, { ActionPlanAssessment: { IsLocked: false } });

            if (areAllActionPlansNotAssessed) {
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.welcome', {}, { location: 'replace' });
                return;
            }

            if (!_.isUndefined(actionPlanToAssess)) {
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias',
                    { ActionPlanID: actionPlanToAssess.ActionPlan.ActionPlanID },
                    { location: 'replace' });
                return;
            }

            $state.go('recomActionPlanUpdateStatusAssess.actionPlans.completed', {}, { location: 'replace' });

            return;
        }

        var title = bUnit.TitleEN + ' Action Plans | ' + govProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.businessUnit = bUnit;
        $scope.govProcess = govProcess;

        // Go To First Action Plan To Assess
        $scope.goToFirstActionPlanToAssess = function () {
            if (!actionPlansByAssessor.length) {
                notificationService.warn('No assessment available');
                return;
            }

            var actionPlanToAssess = _.find(actionPlansByAssessor, { ActionPlanAssessment: { IsLocked: false } });

            $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias',
                        { ActionPlanID: actionPlanToAssess.ActionPlan.ActionPlanID });
        };
    }
})();